import { render, staticRenderFns } from "./DashboardCalendarModal.vue?vue&type=template&id=3a549000&"
import script from "./DashboardCalendarModal.vue?vue&type=script&lang=js&"
export * from "./DashboardCalendarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports